// extracted by mini-css-extract-plugin
export default {"logoBox":"MZSxJK847_iQXILLiNQg"};